import React, { useState, useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import { setLoading, setSnackInfo } from '../../../redux/actions/appAction'
import { getAllMaterials } from '../../../redux/actions/vendorAction'
import { getAllUnits } from '../../../redux/actions/projectAction'
import HttpService from '../../../services/httpService'
import {
  Table, Button, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField,
  Switch, CircularProgress, TablePagination, Typography, Chip, Avatar, IconButton,
  InputAdornment, Divider
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Skeleton from '@material-ui/lab/Skeleton';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Slide from '@material-ui/core/Slide';
import EditIcon from '@material-ui/icons/Edit';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import AddIcon from '@material-ui/icons/Add';
import GetAppIcon from '@material-ui/icons/GetApp';
import StoreIcon from '@material-ui/icons/Store';
import InboxIcon from '@material-ui/icons/Inbox';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Tooltip from '@material-ui/core/Tooltip';
import { Modal } from 'antd';
// import 'antd/dist/antd.css';
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { ROLENAME } from '../../../utils';
import CryptoJs from 'crypto-js';

const ORANGE = "#F47E44";
const ORANGE_DARK = "#c1531f";
const ORANGE_LIGHT = "#fff1ea";
const HEADER_GRADIENT = `linear-gradient(135deg, ${ORANGE_DARK} 0%, ${ORANGE} 60%, #ff9c66 100%)`;
const INK = "#3d2b21";
const GREEN = "#1e7e34";
const GREEN_LIGHT = "#e6f4ea";
const RED = "#c0392b";
const RED_LIGHT = "#fdecea";

const TABLE_COLUMNS = 10;

const BrandLinearProgress = withStyles(() => ({
  root: { height: 4, borderRadius: 999, backgroundColor: "rgba(193,83,31,0.10)" },
  bar: { borderRadius: 999, background: `linear-gradient(90deg, ${ORANGE_DARK}, ${ORANGE}, #ff9c66)` },
}))(LinearProgress);

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  pageRoot: { padding: "4px 4px 24px" },
  headerBanner: {
    display: "flex", alignItems: "center", gap: 16,
    background: HEADER_GRADIENT,
    borderRadius: 16, padding: "16px 26px", marginBottom: 16, color: "#fff",
    boxShadow: "0 8px 24px rgba(93,55,28,0.18)",
    [theme.breakpoints.down('xs')]: { padding: "16px 18px", flexWrap: "wrap" },
  },
  headerIconWrap: {
    display: "flex", alignItems: "center", justifyContent: "center",
    width: 46, height: 46, borderRadius: 14, flexShrink: 0,
    background: "rgba(255,255,255,0.18)",
  },
  headerTitle: { fontSize: 20, fontWeight: 700, color: "#fff", lineHeight: 1.3 },
  headerSubtitle: { fontSize: 13, color: "rgba(255,255,255,0.85)", marginTop: 4 },
  headerActions: { marginLeft: "auto", display: "flex", gap: 10, flexWrap: "wrap" },
  // White on the gradient - a translucent button reads as disabled here.
  whiteBtn: {
    background: "#fff", color: ORANGE_DARK, fontWeight: 700,
    borderRadius: 10, textTransform: "none", padding: "7px 18px",
    boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
    "&:hover": { background: ORANGE_LIGHT },
    "&.Mui-disabled": { background: "rgba(255,255,255,0.8)", color: ORANGE_DARK, boxShadow: "none" },
  },
  // Excel green, so the export reads as an export rather than as a second
  // "Add Vendor". It sits ON the orange banner, so it needs enough depth of
  // its own not to muddy into the gradient - hence the solid fill, the ring
  // and the drop shadow rather than a flat chip.
  excelBtn: {
    // Stops at #23834e rather than going lighter: white on the lightest stop
    // has to clear 4.5:1, and the label is 14px bold, which is not large
    // enough to qualify for the relaxed AA-large threshold.
    background: `linear-gradient(135deg, #145c34 0%, #1D6F42 55%, #23834e 100%)`,
    color: "#fff",
    fontWeight: 700,
    borderRadius: 10,
    textTransform: "none",
    padding: "7px 18px",
    border: "1px solid rgba(255,255,255,0.45)",
    boxShadow: "0 4px 14px rgba(0,0,0,0.22)",
    transition: "transform 160ms ease, box-shadow 160ms ease, filter 160ms ease",
    "&:hover": {
      filter: "brightness(1.08)",
      transform: "translateY(-1px)",
      boxShadow: "0 6px 18px rgba(0,0,0,0.28)",
    },
    "&:active": { transform: "translateY(0)" },
    "&.Mui-disabled": {
      background: "#145c34",
      color: "rgba(255,255,255,0.85)",
      border: "1px solid rgba(255,255,255,0.3)",
      boxShadow: "none",
    },
  },
  progressSlot: { height: 4, marginBottom: 10 },
  loadingBanner: {
    display: "flex", alignItems: "center", gap: 10,
    padding: "9px 14px", marginBottom: 14, borderRadius: 12,
    background: ORANGE_LIGHT, border: `1px solid ${ORANGE}33`,
  },
  loadingBannerTitle: { fontSize: 13, fontWeight: 700, color: ORANGE_DARK },
  loadingBannerHint: { fontSize: 11.5, color: "#7a6a60", marginTop: 1 },
  toolbar: {
    display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap",
    padding: "14px 16px", marginBottom: 14,
    borderRadius: 16, border: "1px solid #eceff3",
    boxShadow: "0 4px 24px rgba(93,55,28,0.08)",
  },
  searchField: { flex: 1, minWidth: 280 },
  searchInputRoot: { borderRadius: 24, background: "#f7f9fc" },
  resultCount: { fontSize: 13, color: "#7c8695", fontWeight: 600, whiteSpace: "nowrap" },
  tableCard: {
    borderRadius: 16, border: "1px solid #eceff3", overflow: "hidden",
    boxShadow: "0 4px 24px rgba(93,55,28,0.08)",
  },
  tableScroll: { maxHeight: "58vh", overflow: "auto" },
  headCell: {
    backgroundColor: ORANGE_DARK, color: "#fff", fontWeight: 700,
    fontSize: 12.5, letterSpacing: 0.3, borderBottom: "none", whiteSpace: "nowrap",
    // stickyHeader paints its own background, so this has to win outright or
    // the rows show through at the seam.
    zIndex: 3,
  },
  bodyCell: { fontSize: 13, color: INK, verticalAlign: "top" },
  vendorCell: { display: "flex", alignItems: "center", gap: 10, minWidth: 0 },
  avatarChip: {
    width: 32, height: 32, fontSize: 12.5, fontWeight: 700, flexShrink: 0,
    background: ORANGE_LIGHT, color: ORANGE_DARK,
  },
  vendorName: { fontWeight: 700, color: INK, lineHeight: 1.3 },
  vendorCompany: { fontSize: 11.5, color: "#8a95a6", marginTop: 1 },
  // Long addresses used to stretch a row to three times its height.
  clamp: {
    display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical",
    overflow: "hidden", maxWidth: 220,
  },
  stackedLine: { display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" },
  subtle: { fontSize: 11.5, color: "#8a95a6", marginTop: 2 },
  docCell: { display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" },
  // A tinted disc rather than a bare glyph, so it reads as a thing to press
  // next to plain text. It lifts and deepens on hover instead of only
  // changing colour, which is easy to miss at 18px.
  docBtn: {
    color: ORANGE_DARK,
    padding: 5,
    background: ORANGE_LIGHT,
    border: `1px solid ${ORANGE}44`,
    transition: "background-color 160ms ease, transform 160ms ease, box-shadow 160ms ease",
    "&:hover": {
      background: ORANGE_DARK,
      color: "#fff",
      transform: "translateY(-1px)",
      boxShadow: "0 3px 8px rgba(193,83,31,0.35)",
    },
  },
  naText: { color: "#b7bfca", fontStyle: "italic", fontSize: 12 },
  actionsCell: { display: "flex", alignItems: "center", gap: 2, whiteSpace: "nowrap" },
  actionBtn: {
    transition: "transform 180ms ease",
    "&:hover": { transform: "scale(1.12)" },
  },
  emptyState: { textAlign: "center", padding: "60px 20px", color: "#9aa5b1" },
  emptyTitle: { marginTop: 10, fontWeight: 700, color: "#7c8695" },
  emptyHint: { color: "#aab3bf", fontSize: 13, marginTop: 2 },
  dialogHeaderBar: {
    display: "flex", alignItems: "center", gap: 12,
    background: HEADER_GRADIENT, color: "#fff", padding: "14px 22px",
  },
  dialogHeaderTitle: { fontSize: 17, fontWeight: 700, color: "#fff" },
  dialogCloseBtn: {
    marginLeft: "auto", color: "#fff", flexShrink: 0,
    transition: "background-color 200ms ease, transform 200ms ease",
    "&:hover": { backgroundColor: "rgba(255,255,255,0.18)", transform: "rotate(90deg)" },
  },
  sectionHeading: {
    display: "flex", alignItems: "center", gap: 8,
    fontSize: 12.5, fontWeight: 700, color: ORANGE_DARK,
    textTransform: "uppercase", letterSpacing: 0.4, margin: "18px 0 10px",
  },
  noteBox: {
    color: "#8a2f24", fontWeight: 600, marginBottom: 15,
    padding: "10px 14px", border: `1px solid ${RED}55`, borderRadius: 10,
    background: RED_LIGHT, fontSize: 13,
  },
  fileRow: {
    display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap",
    background: "#f7f9fc", border: "1px solid #eceff3", borderRadius: 10,
    padding: "8px 12px", marginBottom: 10,
  },
  fileLabel: { fontSize: 12.5, fontWeight: 700, color: INK },
  primaryBtn: {
    background: ORANGE_DARK, color: "#fff", fontWeight: 700,
    borderRadius: 22, textTransform: "none", padding: "7px 22px",
    "&:hover": { background: "#a8441a" },
    "&.Mui-disabled": { background: "#e6e8ec", color: "#9aa5b1" },
  },
  outlineBtn: {
    borderRadius: 22, textTransform: "none", fontWeight: 600,
    color: ORANGE_DARK, border: `1px solid ${ORANGE}66`, padding: "6px 18px",
    "&:hover": { background: ORANGE_LIGHT },
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const initials = (name) => String(name || "")
  .trim().split(/\s+/).slice(0, 2)
  .map((p) => p.charAt(0).toUpperCase())
  .join("") || "?";

const Vendors = (props) => {
  const classes = useStyles();

  const [vendors, setVendors] = useState([])
  const [addVenorModal, setAddVendorModal] = useState(false)
  const [searchField, setSearchField] = useState("")
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [totalCount, setTotalCount] = useState(0)
  const [isEdit, setIsEdit] = useState(false)
  // Local to the table, so a refresh does not blank the whole screen the way
  // the global loader did.
  const [dataLoading, setDataLoading] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const { units } = useSelector(state => state.project)
  const { allMaterials } = useSelector(state => state.vendor)
  const { userDetails } = useSelector(state => state.user)
  const canEditOrBlockVendor = userDetails?.roles?.some(
    role => [ROLENAME.Admin, ROLENAME.FinanceManager, ROLENAME.FinanceExecutive].includes(role.name)
  )
  const [blockDialog, setBlockDialog] = useState({ open: false, vendorId: null, targetBlocked: false, remark: "" })
  const [blockActionLoading, setBlockActionLoading] = useState(false)
  const [editConfirmDialog, setEditConfirmDialog] = useState({ open: false, remark: "" })
  const [editActionLoading, setEditActionLoading] = useState(false)
  const [otpSending, setOtpSending] = useState(false)
  const [otpSent, setOtpSent] = useState(false)
  const [otpValue, setOtpValue] = useState("")
  const [otpResponse, setOtpResponse] = useState({})
  const [otpVerified, setOtpVerified] = useState(false)
  useEffect(() => {
    // Debounced (lazy) server-side search — each keystroke resets the timer, so only
    // the last one within 400ms actually fires the API call.
    const timer = setTimeout(() => {
      getVendors()
    }, searchField ? 400 : 0)
    return () => clearTimeout(timer)
    // eslint-disable-next-line
  }, [page, rowsPerPage, searchField])

  const getVendors = async () => {
    setDataLoading(true)
    try {
      const params = new URLSearchParams({
        page: page + 1,
        limit: rowsPerPage,
        search: searchField
      }).toString()
      const result = await HttpService.getApprovedVendorsPaginated(params)
      setVendors(result.data.vendors)
      setTotalCount(result.data.totalCount)
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    setDataLoading(false)
  }

  // Deliberately NOT the paginated endpoint: vendor/getVendors returns every
  // approved, non-deleted vendor in one call, so the file is the whole list
  // rather than whichever page and search happen to be on screen.
  const downloadExcel = async () => {
    setDownloadLoading(true)
    try {
      const result = await HttpService.getAllVendors()
      const allVendors = result.data || []

      if (!allVendors.length) {
        props.setSnackInfo("No vendors to download", "warning")
        setDownloadLoading(false)
        return
      }

      const excelData = allVendors.map((v, i) => ({
        'Sl No': i + 1,
        'Vendor Unique No': v?.vendorUniqueNo || '',
        'Vendor Name': v?.name || '',
        'Company Name': v?.companyName || '',
        'Category': v?.category || '',
        'Address': v?.address || '',
        'Contact Number': v?.contactNumber || '',
        'Alternate Number': v?.alternateNumber || '',
        'Email': v?.email || '',
        'PAN Number': v?.panNumber || '',
        'Aadhaar Number': v?.aadharNumber || '',
        'GSTIN Number': v?.gstinNumber || '',
        'Website': v?.website || '',
        'Account Holder Name': v?.accountDetails?.accountHolderName || '',
        'Account Number': v?.accountDetails?.accountNumber || '',
        'IFSC': v?.accountDetails?.ifsc || '',
        'Bank Name': v?.accountDetails?.bankName || '',
        'Bank Branch': v?.accountDetails?.bankBranch || '',
        'Status': v?.blocked ? 'Blocked' : 'Active',
        'PAN Card': v?.panCardLink || '',
        'Aadhaar Card': v?.aadharCardLink || '',
        'Bank Statement': v?.bankStatementLink || '',
        'GST Certificate': v?.GstCertificateLink || '',
        'Created At': v?.createdAt ? moment(v.createdAt).format('DD-MM-YYYY') : '',
      }))

      const workbook = XLSX.utils.book_new()
      const worksheet = XLSX.utils.json_to_sheet(excelData)
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Vendors')
      XLSX.writeFile(workbook, `Vendors_${moment().format('DD-MM-YYYY')}.xlsx`)
      props.setSnackInfo(`${allVendors.length} vendors downloaded`, "success")
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Could not download the vendor list", "error")
    }
    setDownloadLoading(false)
  }

  const handleChangePage = (e, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10))
    setPage(0)
  }
  const openBlockDialog = (vendorId, currentlyBlocked) => {
    setBlockDialog({ open: true, vendorId, targetBlocked: !currentlyBlocked, remark: "" })
  }

  const closeBlockDialog = () => {
    setBlockDialog({ open: false, vendorId: null, targetBlocked: false, remark: "" })
  }

  const confirmBlockVendor = async () => {
    if (!blockDialog.remark.trim()) return
    setBlockActionLoading(true)
    props.setLoading(true)
    try {
      await HttpService.blockVendor(blockDialog.vendorId, blockDialog.targetBlocked, blockDialog.remark.trim())
      props.setSnackInfo(`Vendor ${blockDialog.targetBlocked ? 'blocked' : 'unblocked'} successfully`, "success")
      closeBlockDialog()
      getVendors()
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    props.setLoading(false)
    setBlockActionLoading(false)
  }
  const searchVendor = (e) => {
    setSearchField(e.target.value)
    setPage(0)
  }

  const [vendorDetails, setVendorDetails] = useState({
    _id: "",
    name: "",
    companyName: "",
    address: "",
    contactNumber: "",
    email: "",
    panNumber: "",
    gstinNumber: "",
    website: "",
    alternateNumber: "",
    category: "",
    aadharCardLink: "",
    panCardLink: "",
    bankStatementLink: "",
    GstCertificateLink: "",
    aadharNumber: ""
  })

  const [accountDetails, setAccountDetails] = useState({
    accountHolderName: "",
    accountNumber: "",
    ifsc: "",
    bankName: "",
    bankBranch: ""
  })

  const { name, companyName, address, contactNumber, email, panNumber, gstinNumber, website, alternateNumber, category, aadharCardLink, panCardLink, bankStatementLink, aadharNumber, GstCertificateLink } = vendorDetails
  const { accountHolderName, accountNumber, ifsc, bankName, bankBranch } = accountDetails
  const sendVendorOtp = async () => {
    if (!contactNumber || contactNumber.length !== 10) {
      props.setSnackInfo("Enter a valid 10 digit contact number", "warning")
      return
    }
    setOtpSending(true)
    try {
      const response = await HttpService.sendOtpAccordingToContactTypeEmailOrMobile({
        contactType: "whatsapp",
        whatsappNumber: contactNumber
      })
      const bytes = CryptoJs.AES.decrypt(response.data.otp, 'decorpot123')
      const decryptedOtp = bytes.toString(CryptoJs.enc.Utf8)
      setOtpResponse({ otp: Number(decryptedOtp) })
      setOtpSent(true)
      setOtpVerified(false)
      setOtpValue("")
      props.setSnackInfo("OTP sent on WhatsApp", "success")
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.msg ?? error?.response?.data?.message ?? "Failed to send OTP", "error")
    }
    setOtpSending(false)
  }

  const verifyVendorOtp = (e) => {
    const value = e.target.value
    setOtpValue(value)
    setOtpVerified(value.length === 6 && otpResponse.otp === +value)
  }

  const resetVendorOtp = () => {
    setOtpSending(false)
    setOtpSent(false)
    setOtpValue("")
    setOtpResponse({})
    setOtpVerified(false)
  }

  const addVendor = async () => {
    props.setLoading(true)
    try {
      let obj = {
        name, companyName, address, contactNumber, email, panNumber, gstinNumber, website, alternateNumber, accountDetails, category, aadharCardLink, panCardLink, bankStatementLink, aadharNumber, GstCertificateLink
      }
      await HttpService.addVendor(obj)
      props.setSnackInfo('Vendor Sent For Approval', "success")
      getVendors()
      setAddVendorModal(false)
      resetVendorOtp()
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    props.setLoading(false)
  }
  const getVendorById = async (vendorId) => {
    props.setLoading(true)
    try {
      const result = await HttpService.getVendorById(vendorId)
      const { name, companyName, address, contactNumber, email, panNumber, gstinNumber, website, alternateNumber, _id, category, accountDetails, aadharNumber } = result.data
      setVendorDetails({ name, companyName, address, contactNumber, email, panNumber, aadharNumber, gstinNumber, website, category, alternateNumber, _id })
      setAccountDetails(accountDetails)
      setIsEdit(true)
      setAddVendorModal(true)
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    props.setLoading(false)
  }
  const openEditConfirmDialog = () => {
    setEditConfirmDialog({ open: true, remark: "" })
  }

  const closeEditConfirmDialog = () => {
    setEditConfirmDialog({ open: false, remark: "" })
  }
  const editVendor = async () => {
    if (!editConfirmDialog.remark.trim()) return
    setEditActionLoading(true)
    props.setLoading(true)

    try {
      await HttpService.editVendor({ ...vendorDetails, accountDetails: { ...accountDetails }, remark: editConfirmDialog.remark.trim() })
      setIsEdit(false)
      setAddVendorModal(false)
      closeEditConfirmDialog()
      getVendors()
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    props.setLoading(false)
    setEditActionLoading(false)
  }

  const [showVendorMaterialsModal, setShowVendorMaterialsModal] = useState(false)
  const [rowsToAdd, setRowsToAdd] = useState(0)
  const [selectedUom, setSelectedUom] = useState([])
  const [materials, setMaterials] = useState([])
  const [pricePerUnit, setPricePerUnit] = useState([])
  const [tableRows, setTableRows] = useState([{ value: null }])
  // const [allMaterials, setAllMaterials] = useState([])
  const [selectedVendor, setSelectedVendor] = useState("")

  const openVendorMaterialsModal = async (vendorId) => {
    props.setLoading(true)
    try {
      setSelectedVendor(vendorId)
      await props.getAllUnits()
      await getAllMaterials()
      const result = await HttpService.getVendorMaterialById(vendorId)
      console.log(result.data, "result")
      if (result.data?.length > 0) {
        addRows(null, result.data?.length)
        let uom = [...selectedUom]
        let material = [...materials]
        let price = [...pricePerUnit]
        result.data?.map((item, i) => {
          uom[i] = item.unitId
          material[i] = item.materialId
          price[i] = item.pricePerUnit
          return null
        })
        setSelectedUom(uom)
        setMaterials(material)
        setPricePerUnit(price)
      } else {
        setPricePerUnit([])
        setSelectedUom([])
        setMaterials([])
        setTableRows([{ value: null }])
      }
      setShowVendorMaterialsModal(true)
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    props.setLoading(false)
  }
  const getAllMaterials = async () => {
    try {
      await props.getAllMaterials()
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")

    }
  }

  const addRows = (e, value) => {
    let length = value ?? rowsToAdd
    const rows = [...tableRows];
    for (let i = 0; i < length; i++) {
      rows.push({ value: null })
    }
    setTableRows(rows)
    setRowsToAdd(0)
  }

  const handleUomSelect = (e, v, i) => {
    let uom = [...selectedUom]
    uom[i] = v
    setSelectedUom(uom)
  }
  const getSelectedUom = (i) => {
    const item = selectedUom[i]
    return item || {}
  }
  const getMaterial = (i) => {
    const item = materials[i]
    return item || []
  }
  const getPricePerUnit = (i) => {
    const item = pricePerUnit[i]
    return item || ""
  }

  const handleMaterial = (e, v, i) => {
    let material = [...materials]
    material[i] = v
    setMaterials(material)
  }

  const handlePrice = (e, i) => {
    let price = [...pricePerUnit]
    price[i] = e.target.value
    setPricePerUnit(price)
  }

  const submit = async () => {
    props.setLoading(true)
    try {
      const obj = materials.map((material, i) => {
        return {
          materialId: material,
          vendorId: selectedVendor,
          unitId: selectedUom[i],
          pricePerUnit: pricePerUnit[i]
        }
      })

      let res = await HttpService.mapMaterialsForVendor(selectedVendor, obj)

      props.setSnackInfo(res.data, "success")

      closeVendorMaterialMapModal()
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    props.setLoading(false)
  }

  const closeVendorMaterialMapModal = () => {
    setShowVendorMaterialsModal(false)
    setSelectedVendor("")
    setPricePerUnit([])
    setSelectedUom([])
    setMaterials([])
    setTableRows([{ value: null }])
  }

  const handlePanCard = (e) => {
    const { name, value } = e.target;
    let convert = value.toUpperCase()
    setVendorDetails({ ...vendorDetails, [e.target.name]: convert })
  }


  const handleFileInput = async (e) => {
    props.setLoading(true)
    const formData = new FormData()
    formData.append('file', e.target.files[0])
    formData.append('vendorName', vendorDetails.name)
    const result = await HttpService.uploadVendorDocs(formData)

    switch (e.target.id) {
      case 'addAadhar':
        setVendorDetails({ ...vendorDetails, aadharCardLink: result.data })
        break;
      case 'updateAadhar':
        setVendorDetails({ ...vendorDetails, aadharCardLink: result.data })
        break;
      case 'addPan':
        setVendorDetails({ ...vendorDetails, panCardLink: result.data })
        break;
      case 'updatePan':
        setVendorDetails({ ...vendorDetails, panCardLink: result.data })
        break;
      case 'addBank':
        setVendorDetails({ ...vendorDetails, bankStatementLink: result.data })
        break;
      case 'updateBank':
        setVendorDetails({ ...vendorDetails, bankStatementLink: result.data })
        break;
      case 'addGst':
        setVendorDetails({ ...vendorDetails, GstCertificateLink: result.data })
        break;
      case 'updateGst':
        setVendorDetails({ ...vendorDetails, GstCertificateLink: result.data })
        break;
      default:
        console.log("default")
    }
    props.setLoading(false)
  }

  // Backdrop click, Esc and the header X all go through here, so the three
  // ways out of the dialog cannot drift apart.
  const closeAddVendorModal = () => {
    setAddVendorModal(false)
  }

  const handleAddVendorButton = () => {
    setIsEdit(false)
    setVendorDetails({
      _id: "",
      name: "",
      companyName: "",
      address: "",
      contactNumber: "",
      email: "",
      panNumber: "",
      aadharNumber: "",
      gstinNumber: "",
      website: "",
      alternateNumber: "",
      category: "",
      aadharCardLink: "",
      panCardLink: "",
      bankStatementLink: "",
      GstCertificateLink: "",
    })
    setAccountDetails({
      accountHolderName: "",
      accountNumber: "",
      ifsc: "",
      bankName: "",
      bankBranch: ""
    })
    resetVendorOtp()
    setAddVendorModal(true)

  }

  // A link cell: the number, and the document beside it when one exists.
  //
  // CloudDownloadIcon rather than a plain document glyph: these files are
  // stored on S3 without a ContentType, so the browser is handed
  // binary/octet-stream and saves the file instead of displaying it - the
  // action really is a download, and the icon should say so. A page icon read
  // as "view", which is not what happens.
  const docLink = (value, link, title) => (
    <div className={classes.docCell}>
      <span>{value || <span className={classes.naText}>—</span>}</span>
      {link ? (
        <Tooltip title={title}>
          <IconButton size="small" className={classes.docBtn} onClick={() => window.open(link)}>
            <CloudDownloadIcon style={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      ) : null}
    </div>
  )

  return (
    <div className={classes.pageRoot}>

      <div className={classes.headerBanner}>
        <div className={classes.headerIconWrap}>
          <StoreIcon />
        </div>
        <div>
          <Typography className={classes.headerTitle}>Vendors</Typography>
          <Typography className={classes.headerSubtitle}>
            Approved vendors, their documents and material price mappings
          </Typography>
        </div>
        <div className={classes.headerActions}>
          <Tooltip title={`Downloads every approved vendor as .xlsx, not just this page${totalCount ? ` (${totalCount} on record)` : ''}`}>
            <span>
              <Button
                className={classes.excelBtn}
                disabled={downloadLoading}
                onClick={downloadExcel}
                // Spinner in white, not orange - it sits on the green fill now.
                startIcon={downloadLoading
                  ? <CircularProgress size={15} thickness={5} style={{ color: "#fff" }} />
                  : <GetAppIcon />}
              >
                {downloadLoading ? 'Preparing…' : 'Download Excel'}
              </Button>
            </span>
          </Tooltip>
          <Button
            className={classes.whiteBtn}
            onClick={() => handleAddVendorButton()}
            startIcon={<AddIcon />}
          >
            Add Vendor
          </Button>
        </div>
      </div>

      {/* Reserved slot, so a search does not jog the table down 4px and back. */}
      <div className={classes.progressSlot}>
        {dataLoading ? <BrandLinearProgress /> : null}
      </div>

      {dataLoading && (
        <div className={classes.loadingBanner}>
          <CircularProgress size={17} thickness={5} style={{ color: ORANGE_DARK }} />
          <div style={{ minWidth: 0 }}>
            <div className={classes.loadingBannerTitle}>Fetching vendors…</div>
            <div className={classes.loadingBannerHint}>
              {searchField
                ? `Searching approved vendors for “${searchField}”.`
                : 'Loading the approved vendor list.'}
            </div>
          </div>
        </div>
      )}

      <Paper className={classes.toolbar} elevation={0}>
        <TextField
          className={classes.searchField}
          label="Search Vendors"
          placeholder="Name, company, contact, email or vendor no."
          value={searchField}
          name="name"
          onChange={searchVendor}
          variant="outlined"
          size="small"
          InputProps={{
            classes: { root: classes.searchInputRoot },
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" style={{ color: "#8a95a6" }} />
              </InputAdornment>
            ),
            endAdornment: searchField && (
              <InputAdornment position="end">
                <Tooltip title="Clear search">
                  <IconButton size="small" onClick={() => { setSearchField(""); setPage(0) }}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
        <Typography className={classes.resultCount}>
          {dataLoading && !vendors?.length ? '…' : `${totalCount} vendor${totalCount === 1 ? '' : 's'}`}
        </Typography>
      </Paper>

      <Paper className={classes.tableCard} elevation={0}>
        <TableContainer className={classes.tableScroll}>
          <Table className={classes.table} size="small" stickyHeader aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell className={classes.headCell}>Sl No</TableCell>
                <TableCell className={classes.headCell}>Vendor No</TableCell>
                <TableCell className={classes.headCell}>Vendor</TableCell>
                <TableCell className={classes.headCell}>Contact</TableCell>
                <TableCell className={classes.headCell}>Address</TableCell>
                <TableCell className={classes.headCell}>PAN</TableCell>
                <TableCell className={classes.headCell}>Aadhaar</TableCell>
                <TableCell className={classes.headCell}>Bank A/C</TableCell>
                <TableCell className={classes.headCell}>Status</TableCell>
                <TableCell className={classes.headCell} align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataLoading && !vendors?.length ? (
                [...Array(6)].map((_, i) => (
                  <TableRow key={`sk-${i}`}>
                    {[...Array(TABLE_COLUMNS)].map((__, c) => (
                      <TableCell key={c}><Skeleton height={22} /></TableCell>
                    ))}
                  </TableRow>
                ))
              ) : !vendors?.length ? (
                <TableRow>
                  <TableCell colSpan={TABLE_COLUMNS} style={{ borderBottom: "none" }}>
                    <div className={classes.emptyState}>
                      {searchField ? (
                        <>
                          <FindInPageIcon style={{ fontSize: 46, color: "#c9d2de" }} />
                          <Typography className={classes.emptyTitle}>
                            No vendor matches “{searchField}”
                          </Typography>
                          <Typography className={classes.emptyHint}>
                            Try the vendor number, company name or contact number.
                          </Typography>
                        </>
                      ) : (
                        <>
                          <InboxIcon style={{ fontSize: 46, color: "#c9d2de" }} />
                          <Typography className={classes.emptyTitle}>No approved vendors yet</Typography>
                          <Typography className={classes.emptyHint}>
                            Vendors appear here once their onboarding is approved.
                          </Typography>
                        </>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                vendors.map((data, i) => (
                  <StyledTableRow key={i + 1}>
                    {/* Continues across pages - page 2 starts at 11, not 1 -
                        since the server returns only the current page's rows. */}
                    <TableCell className={classes.bodyCell} style={{ color: "#8a95a6", whiteSpace: "nowrap" }}>
                      {page * rowsPerPage + i + 1}
                    </TableCell>

                    <TableCell className={classes.bodyCell} style={{ fontWeight: 700, color: ORANGE_DARK, whiteSpace: "nowrap" }}>
                      {data?.vendorUniqueNo || <span className={classes.naText}>—</span>}
                    </TableCell>

                    <TableCell className={classes.bodyCell}>
                      <div className={classes.vendorCell}>
                        <Avatar className={classes.avatarChip}>{initials(data?.name)}</Avatar>
                        <div style={{ minWidth: 0 }}>
                          <div className={classes.vendorName}>{data?.name}</div>
                          {data?.companyName && (
                            <div className={classes.vendorCompany}>{data.companyName}</div>
                          )}
                        </div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.bodyCell}>
                      <div className={classes.stackedLine}>{data?.contactNumber}</div>
                      {data?.email && <div className={classes.subtle}>{data.email}</div>}
                    </TableCell>

                    <TableCell className={classes.bodyCell}>
                      <Tooltip title={data?.address || ''}>
                        <div className={classes.clamp}>
                          {data?.address || <span className={classes.naText}>—</span>}
                        </div>
                      </Tooltip>
                    </TableCell>

                    <TableCell className={classes.bodyCell}>
                      {docLink(data?.panNumber, data?.panCardLink, 'Download PAN card')}
                    </TableCell>

                    <TableCell className={classes.bodyCell}>
                      {docLink(data?.aadharNumber, data?.aadharCardLink, 'Download Aadhaar card')}
                    </TableCell>

                    <TableCell className={classes.bodyCell}>
                      {docLink(data?.accountDetails?.accountNumber, data?.bankStatementLink, 'Download bank statement')}
                    </TableCell>

                    <TableCell className={classes.bodyCell}>
                      <Chip
                        size="small"
                        icon={data?.blocked
                          ? <BlockIcon style={{ fontSize: 15, color: RED }} />
                          : <CheckCircleIcon style={{ fontSize: 15, color: GREEN }} />}
                        label={data?.blocked ? 'Blocked' : 'Active'}
                        style={{
                          fontWeight: 700,
                          background: data?.blocked ? RED_LIGHT : GREEN_LIGHT,
                          color: data?.blocked ? RED : GREEN,
                        }}
                      />
                    </TableCell>

                    {/* The old markup nested a <tr>/<td> inside this cell, which
                        is not valid table HTML - a plain flex row does the same
                        job without the browser silently re-parenting it. */}
                    <TableCell className={classes.bodyCell} align="center">
                      <div className={classes.actionsCell} style={{ justifyContent: 'center' }}>
                        <Tooltip title="Edit Mapping">
                          <IconButton size="small" className={classes.actionBtn} onClick={() => openVendorMaterialsModal(data._id)}>
                            <BorderColorIcon fontSize="small" style={{ color: ORANGE_DARK }} />
                          </IconButton>
                        </Tooltip>
                        {canEditOrBlockVendor && (
                          <Tooltip title="Edit Vendor">
                            <IconButton size="small" className={classes.actionBtn} onClick={() => getVendorById(data._id)}>
                              <EditIcon fontSize="small" style={{ color: ORANGE_DARK }} />
                            </IconButton>
                          </Tooltip>
                        )}
                        {canEditOrBlockVendor && (
                          <Tooltip title={data?.blocked ? "Unblock Vendor" : "Block Vendor"}>
                            <Switch
                              checked={!!data?.blocked}
                              onChange={() => openBlockDialog(data._id, data?.blocked)}
                              color="primary"
                              size="small"
                            />
                          </Tooltip>
                        )}
                      </div>
                    </TableCell>
                  </StyledTableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
        />
      </Paper>

      <Dialog
        open={addVenorModal}
        TransitionComponent={Transition}
        keepMounted
        fullWidth={true}
        maxWidth={'sm'}
        onClose={closeAddVendorModal}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{ style: { borderRadius: 16 } }}
      >
        <div className={classes.dialogHeaderBar}>
          <StoreIcon />
          <Typography className={classes.dialogHeaderTitle} id="alert-dialog-slide-title">
            {isEdit ? "Update Vendor" : "Add Vendor"}
          </Typography>
          <Tooltip title="Close">
            <IconButton
              className={classes.dialogCloseBtn}
              size="small"
              aria-label="Close"
              onClick={closeAddVendorModal}
            >
              <ClearIcon />
            </IconButton>
          </Tooltip>
        </div>
        <DialogContent style={{ paddingTop: 18 }}>
          {!isEdit && (
            <div className={classes.noteBox}>
              Note: Onboarding a new vendor requires WhatsApp OTP verification. Please make sure the vendor is available to share the OTP sent to their WhatsApp number.
            </div>
          )}
          <DialogContentText id="alert-dialog-slide-description" style={{ display: "flex", flexDirection: "column" }}>
            <div className={classes.sectionHeading}>Vendor Details</div>
            <TextField label="Vendor Name" style={{ marginBottom: 10 }} name="name" value={name} onChange={(e) => setVendorDetails({ ...vendorDetails, [e.target.name]: e.target.value })} variant="outlined" />
            <TextField label="Company Name" style={{ marginBottom: 10 }} name="companyName" value={companyName} onChange={(e) => setVendorDetails({ ...vendorDetails, [e.target.name]: e.target.value })} variant="outlined" />
            <TextField label="Category" style={{ marginBottom: 10 }} name="category" value={category} onChange={(e) => setVendorDetails({ ...vendorDetails, [e.target.name]: e.target.value })} variant="outlined" />
            <TextField label="Vendor Address" multiline={true} rows={3} style={{ marginBottom: 10 }} name="address" value={address} onChange={(e) => setVendorDetails({ ...vendorDetails, [e.target.name]: e.target.value })} variant="outlined" />
            <TextField
              label="Contact Number"
              style={{ marginBottom: 10 }}
              name="contactNumber"
              value={contactNumber}
              onChange={(e) => {
                setVendorDetails({ ...vendorDetails, [e.target.name]: e.target.value })
                if (otpSent) resetVendorOtp()
              }}
              variant="outlined"
            />
            {!isEdit && (
              <div style={{ display: "flex", alignItems: "center", marginBottom: 10, gap: 10, flexWrap: "wrap" }}>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: (otpSending || otpVerified || contactNumber?.length !== 10) ? "#c4c4c4" : ORANGE_DARK,
                    color: (otpSending || otpVerified || contactNumber?.length !== 10) ? "#7a7a7a" : "#FFF2EB",
                    textTransform: "none", fontWeight: 700, borderRadius: 22,
                  }}
                  disabled={otpSending || otpVerified || contactNumber?.length !== 10}
                  onClick={sendVendorOtp}
                >
                  {otpSending ? <CircularProgress size={20} color="inherit" /> : (otpSent ? "Resend OTP" : "Send OTP on WhatsApp")}
                </Button>
                {otpSent && !otpVerified && (
                  <TextField
                    label="Enter OTP"
                    value={otpValue}
                    onChange={verifyVendorOtp}
                    variant="outlined"
                    size="small"
                  />
                )}
                {otpVerified && (
                  <Chip
                    size="small"
                    icon={<CheckCircleIcon style={{ fontSize: 16, color: GREEN }} />}
                    label="OTP Verified"
                    style={{ background: GREEN_LIGHT, color: GREEN, fontWeight: 700 }}
                  />
                )}
              </div>
            )}
            <TextField label="Alternate Contact Number" style={{ marginBottom: 10 }} name="alternateNumber" value={alternateNumber} onChange={(e) => setVendorDetails({ ...vendorDetails, [e.target.name]: e.target.value })} variant="outlined" />
            <TextField label="Email" style={{ marginBottom: 10 }} name="email" value={email} onChange={(e) => setVendorDetails({ ...vendorDetails, [e.target.name]: e.target.value })} variant="outlined" />

            <div className={classes.sectionHeading}>Identity</div>
            <TextField label={<> Aadhar Number<sup style={{ color: "red" }}>*</sup> </>} style={{ marginBottom: 10 }} name="aadharNumber" value={aadharNumber} onChange={(e) => setVendorDetails({ ...vendorDetails, [e.target.name]: e.target.value })} variant="outlined" />
            <div className={classes.fileRow}>
              {isEdit
                ? <><span className={classes.fileLabel}>Update Aadhaar Card</span><input accept="*" id="updateAadhar" onChange={(e) => handleFileInput(e)} type="file" /></>
                : <><span className={classes.fileLabel}>Add Aadhaar Card <sup style={{ color: "red" }}>*</sup></span><input accept="*" id="addAadhar" onChange={(e) => handleFileInput(e)} type="file" /></>}
            </div>

            <div className={classes.sectionHeading}>Vendor A/C Details</div>
            <TextField label="Account Holder Name" style={{ marginBottom: 10 }} name="accountHolderName" value={accountHolderName} onChange={(e) => setAccountDetails({ ...accountDetails, [e.target.name]: e.target.value })} variant="outlined" />
            <TextField label="Account Number " style={{ marginBottom: 10 }} name="accountNumber" value={accountNumber} onChange={(e) => setAccountDetails({ ...accountDetails, [e.target.name]: e.target.value })} variant="outlined" />
            <TextField label="IFSC CODE" style={{ marginBottom: 10 }} name="ifsc" value={ifsc} onChange={(e) => setAccountDetails({ ...accountDetails, [e.target.name]: e.target.value.toUpperCase() })} variant="outlined" />
            <TextField label="Bank Name" style={{ marginBottom: 10 }} name="bankName" value={bankName} onChange={(e) => setAccountDetails({ ...accountDetails, [e.target.name]: e.target.value })} variant="outlined" />
            <TextField label="Bank Branch" style={{ marginBottom: 10 }} name="bankBranch" value={bankBranch} onChange={(e) => setAccountDetails({ ...accountDetails, [e.target.name]: e.target.value })} variant="outlined" />
            <div className={classes.fileRow}>
              {isEdit
                ? <><span className={classes.fileLabel}>Update Bank Statement</span><input type="file" id='updateBank' onChange={e => handleFileInput(e)} /></>
                : <><span className={classes.fileLabel}>Add Bank Statement</span><input type="file" id='addBank' onChange={e => handleFileInput(e)} /></>}
            </div>

            <div className={classes.sectionHeading}>Tax</div>
            <TextField label={<> PAN Number<sup style={{ color: "red" }}>*</sup> </>} style={{ marginBottom: 10 }} name="panNumber" value={panNumber} onChange={(e) => handlePanCard(e)} variant="outlined" />
            <div className={classes.fileRow}>
              {isEdit
                ? <><span className={classes.fileLabel}>Update PAN Card</span><input type="file" id='updatePan' onChange={e => handleFileInput(e)} /></>
                : <><span className={classes.fileLabel}>Add PAN Card <sup style={{ color: "red" }}>*</sup></span><input type="file" id='addPan' onChange={e => handleFileInput(e)} /></>}
            </div>
            <TextField label="GSTIN Number" style={{ marginBottom: 10 }} name="gstinNumber" value={gstinNumber} onChange={(e) => setVendorDetails({ ...vendorDetails, [e.target.name]: e.target.value })} variant="outlined" />
            <TextField label="Website" style={{ marginBottom: 10 }} name="website" value={website} onChange={(e) => setVendorDetails({ ...vendorDetails, [e.target.name]: e.target.value })} variant="outlined" />
            <div className={classes.fileRow}>
              {isEdit
                ? <><span className={classes.fileLabel}>Update GST Certificate</span><input type="file" id='updateGst' onChange={e => handleFileInput(e)} /></>
                : <><span className={classes.fileLabel}>GST Certificate <sup style={{ color: "red" }}>*</sup></span><input type="file" id='addGst' onChange={e => handleFileInput(e)} /></>}
            </div>
          </DialogContentText>
          <Divider style={{ margin: "6px 0 2px" }} />
          <DialogActions>
            {
              isEdit
                ? <Button onClick={openEditConfirmDialog} className={classes.primaryBtn}> UPDATE </Button>
                : <Button onClick={addVendor} className={classes.primaryBtn} disabled={vendorDetails.aadharNumber === "" || vendorDetails.panNumber === "" || vendorDetails.aadharCardLink === "" || vendorDetails.panCardLink === "" || vendorDetails.GstCertificateLink === "" || !otpVerified}> Add</Button>
            }
          </DialogActions>
        </DialogContent>

      </Dialog>

      <Modal
        title="Vendor Mapped Materials"
        centered
        visible={showVendorMaterialsModal}
        onCancel={closeVendorMaterialMapModal}
        width={1000}
        maskClosable={false}
        footer={null}
      >
        <TableContainer component={Paper}>
          <Table className={classes.table} size="small" aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Sl No</StyledTableCell>
                <StyledTableCell>Material Name</StyledTableCell>
                <StyledTableCell>Material Code</StyledTableCell>
                <StyledTableCell>Price</StyledTableCell>
                <StyledTableCell>Unit</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableRows?.map((data, i) => (
                <StyledTableRow key={i + 1}>
                  <StyledTableCell>{i + 1}</StyledTableCell>
                  <StyledTableCell><Autocomplete
                    value={getMaterial(i)}
                    onChange={(e, v) => handleMaterial(e, v, i)}
                    options={allMaterials}
                    getOptionLabel={(option) => option.name}
                    style={{ width: 250 }}
                    renderInput={(params) => <TextField {...params} label="Materials" fullWidth variant="outlined" />}
                  /></StyledTableCell>
                  <StyledTableCell><TextField disabled={true} className={classes.textField} value={materials[i]?.name} variant="outlined" /></StyledTableCell>
                  <StyledTableCell><TextField className={classes.textField} onChange={(e) => handlePrice(e, i)} type="number" value={getPricePerUnit(i)} variant="outlined" /></StyledTableCell>
                  <StyledTableCell><Autocomplete
                    value={getSelectedUom(i)}
                    onChange={(e, v) => handleUomSelect(e, v, i)}
                    options={units}
                    getOptionLabel={(option) => option.name}
                    style={{ width: 150 }}
                    renderInput={(params) => <TextField {...params} label="Select UOM" fullWidth variant="outlined" />}
                  /></StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div style={{ display: "flex", flexDirection: "row-reverse", marginTop: 15 }} >
          <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} onClick={addRows}>
            Add Row
          </Button>
          <TextField label="Rows to add" value={rowsToAdd} type="number" onChange={(e) => setRowsToAdd(e.target.value)} variant="outlined" />
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }} onClick={submit} >
          <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} >
            Save
          </Button>
        </div>
      </Modal>
      <Dialog
        open={blockDialog.open}
        onClose={closeBlockDialog}
        aria-labelledby="block-vendor-dialog-title"
        aria-describedby="block-vendor-dialog-description"
        PaperProps={{ style: { borderRadius: 16 } }}
      >
        <div className={classes.dialogHeaderBar} style={{ background: blockDialog.targetBlocked ? `linear-gradient(135deg, ${RED} 0%, #d9583f 100%)` : HEADER_GRADIENT }}>
          {blockDialog.targetBlocked ? <BlockIcon /> : <CheckCircleIcon />}
          <Typography className={classes.dialogHeaderTitle} id="block-vendor-dialog-title">
            {blockDialog.targetBlocked ? "Block Vendor" : "Unblock Vendor"}
          </Typography>
        </div>
        <DialogContent style={{ paddingTop: 18 }}>
          <DialogContentText id="block-vendor-dialog-description">
            Are you sure you want to {blockDialog.targetBlocked ? "block" : "unblock"} this vendor?
          </DialogContentText>
          <TextField
            label={<>Remark<sup style={{ color: "red" }}>*</sup></>}
            fullWidth
            multiline
            rows={3}
            value={blockDialog.remark}
            onChange={(e) => setBlockDialog({ ...blockDialog, remark: e.target.value })}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions style={{ padding: "8px 20px 18px" }}>
          <Button onClick={closeBlockDialog} className={classes.outlineBtn} disabled={blockActionLoading}>No</Button>
          <Button
            onClick={confirmBlockVendor}
            className={classes.primaryBtn}
            disabled={!blockDialog.remark.trim() || blockActionLoading}
          >
            {blockActionLoading ? <CircularProgress size={20} color="inherit" /> : "Yes"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={editConfirmDialog.open}
        onClose={closeEditConfirmDialog}
        aria-labelledby="edit-vendor-confirm-dialog-title"
        aria-describedby="edit-vendor-confirm-dialog-description"
        PaperProps={{ style: { borderRadius: 16 } }}
      >
        <div className={classes.dialogHeaderBar}>
          <EditIcon />
          <Typography className={classes.dialogHeaderTitle} id="edit-vendor-confirm-dialog-title">
            Update Vendor
          </Typography>
        </div>
        <DialogContent style={{ paddingTop: 18 }}>
          <DialogContentText id="edit-vendor-confirm-dialog-description">
            Are you sure you want to update this vendor's details?
          </DialogContentText>
          <TextField
            label={<>Remark<sup style={{ color: "red" }}>*</sup></>}
            fullWidth
            multiline
            rows={3}
            value={editConfirmDialog.remark}
            onChange={(e) => setEditConfirmDialog({ ...editConfirmDialog, remark: e.target.value })}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions style={{ padding: "8px 20px 18px" }}>
          <Button onClick={closeEditConfirmDialog} className={classes.outlineBtn} disabled={editActionLoading}>No</Button>
          <Button
            onClick={editVendor}
            className={classes.primaryBtn}
            disabled={!editConfirmDialog.remark.trim() || editActionLoading}
          >
            {editActionLoading ? <CircularProgress size={20} color="inherit" /> : "Yes"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default connect(null, { setLoading, setSnackInfo, getAllUnits, getAllMaterials })(Vendors)
